export const getSearchTable = (t, isFreshness, isSelectExcel = false, handleDeleteClick) => {
    return {
        heads: [
            {
                title: t('price_registration.result_list.jan.title'),
                ...(!handleDeleteClick // 売価登録一覧では表示しないため
                    ? {
                          field: 'jan',
                      }
                    : {}),
                className: 'v-base_minWidth--95 v-base_width--6',
            },
            {
                title: t('price_registration.result_list.commodity_classification.title'),
                className: 'v-base_minWidth--65 v-width-auto',
            },
            !handleDeleteClick && {
                title: t('price_registration.result_list.product_image.title'),
                className: 'v-base_minWidth--30 v-base_width--3',
            },
            {
                title: t('price_registration.result_list.product_name.title'),
                ...(!handleDeleteClick // 売価登録一覧では表示しないため
                    ? {
                          field: 'itemName',
                      }
                    : {}),
                className: 'v-base_minWidth--120 cell-border',
            },
            {
                title: t('price_registration.result_list.list_price.title'),
                className: 'text-center',
            },
            {
                title: t('price_registration.result_list.unit.title'),
                className: 'text-center cell-border',
            },
            {
                title: t('price_registration.result_list.store_standard_selling_price.title'),
                className: 'text-center cell-border',
            },
            {
                title: t('price_registration.result_list.selling_price_type.title'),
                className: 'text-center',
            },
            {
                title: t('price_registration.result_list.store_current_selling_price.title'),
                className: 'text-center',
            },
            {
                title: t('price_registration.result_list.store_current_unit_price.title'),
                className: 'text-center',
            },
            {
                title: t('price_registration.result_list.end_date.title'),
                className: `text-center ${isFreshness && 'cell-border'}`,
            },
            !isFreshness && {
                title: t('price_registration.result_list.competitor_name.title'),
                className: 'text-center cell-border',
            },
            {
                title: t('price_registration.result_list.nbpbkbn.title'),
                className: 'text-center v-base_minWidth--60',
            },
            isSelectExcel && {
                title: t('user.label.delete'),
                className: 'v-base_minWidth--40 v-base_width--2',
            },
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    field: 'itemCategoryName',
                },
                !handleDeleteClick && {
                    isLink: true,
                },
                {
                    field: 'itemName',
                    className: 'freeze-right-0 cell-border text-left',
                },
                {
                    field: 'listPrice',
                },
                {
                    unit: true,
                    field: 'capacityOfUnit',
                    duoField: 'unit',
                    className: 'freeze-right-0 cell-border',
                },
                {
                    // テーブルでは更徳と比較して安い金額を表示
                    field: 'discountedEdlpSellingPrice',
                    duoField: 'edlpSellingPrice',
                    className: 'freeze-right-0 cell-border',
                },
                {
                    field: 'lowestPriceTypeName',
                },
                {
                    field: 'discountedLowestSellingPrice',
                    duoField: 'lowestSellingPrice',
                    colorRed: true,
                },
                {
                    field: 'lowestSellingUnitPrice',
                    duoField: 'quantityOfUnit',
                    trioField: 'unit',
                },
                {
                    field: 'effectiveEndDate',
                    className: `${isFreshness && 'freeze-right-0 cell-border'}`,
                },
                !isFreshness && {
                    field: 'competitorName',
                    className: 'freeze-right-0 cell-border',
                },
                {
                    field: 'nbpbkbn',
                },
                isSelectExcel &&
                    handleDeleteClick && {
                        field: 'delete',
                        isButtonDelete: true,
                        onClick: (index, value) => {
                            handleDeleteClick(index, value);
                        },
                    },
            ],
        },
    };
};

export const getCompetitorRequestTable = (t, expandSalesFloors, packingCategories, saleTypes, taxIncludedType) => {
    return {
        heads: [
            {
                title: t('price_registration.registration_list_modal.jan'),
                field: 'jan',
                className: 'v-base_minWidth--95 v-base_width--6',
            },
            {
                title: t('price_registration.registration_list_modal.product_name.title'),
                field: 'itemName',
                className: 'v-base_minWidth--95 v-base_width--6',
            },
            {
                title: t('price_registration.registration_list_modal.sales_floor_development'),
                field: 'expandSalesFloor',
                className: 'text-center',
            },
            {
                title: t('price_request.result_list.discounted_competitor_selling_price'),
                field: 'discountedRequestSellingPrice',
                className: 'text-center',
            },
            {
                title: t('price_registration.registration_list_modal.sales_conditions'),
                field: 'packingCategory',
                className: 'text-center',
            },
            {
                title: t('price_registration.registration_list_modal.sale_type'),
                field: 'saleType',
                className: 'text-center',
            },
            {
                title: t('price_registration.registration_list_modal.start_date'),
                field: 'salesStartDate',
                className: 'text-center',
            },
            {
                title: t('price_registration.registration_list_modal.end_date'),
                field: 'salesEndDate',
                className: 'text-center',
            },
            {
                title: t('price_registration.registration_list_modal.tax'),
                className: 'text-center',
            },
            {
                title: t('price_registration.registration_list_modal.other_noteworthy_things'),
                field: 'otherSpecialReports',
                className: 'text-center v-base_minWidth--220',
            },
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    field: 'itemName',
                    className: 'text-left',
                },
                {
                    field: 'expandSalesFloor',
                    mappingData: expandSalesFloors,
                },
                taxIncludedType === 'included'
                    ? {
                          field: 'discountedRequestSellingPriceTax',
                          duoField: 'requestSellingPriceTax',
                          colorRed: true,
                      }
                    : {
                          field: 'discountedRequestSellingPrice',
                          duoField: 'requestSellingPrice',
                          colorRed: true,
                      },
                {
                    field: 'packingCategory',
                    mappingData: packingCategories,
                },
                {
                    field: 'saleType',
                    mappingData: saleTypes,
                },
                {
                    field: 'salesStartDate',
                },
                {
                    field: 'salesEndDate',
                },
                {
                    field: 'tax',
                    value: taxIncludedType,
                },
                {
                    field: 'otherSpecialReports',
                },
            ],
        },
    };
};

export const getFreshnessRequestTable = (t, taxIncludedType) => {
    return {
        heads: [
            {
                title: 'JAN',
                field: 'jan',
                className: 'v-base_minWidth--95 v-base_width--6',
            },
            {
                title: '商品名',
                field: 'itemName',
                className: 'v-base_minWidth--95 v-base_width--6',
            },
            {
                title: '鮮度起因値下げ',
                field: 'discountedRequestSellingPrice',
                className: 'text-center',
            },
            {
                title: '開始日',
                field: 'startDate',
                className: 'text-center',
            },
            {
                title: '終了日',
                field: 'endDate',
                className: 'text-center',
            },
            {
                title: '鮮度起因値下げ理由',
                field: 'freshnessReason',
                className: 'text-center',
            },
            {
                title: t('price_registration.registration_list_modal.tax'),
                className: 'text-center',
            },
            {
                title: 'その他特記事項',
                field: 'otherSpecialReports',
                className: 'text-center v-base_minWidth--220',
            },
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    field: 'itemName',
                    className: 'text-left',
                },
                taxIncludedType === 'included'
                    ? {
                          field: 'discountedRequestSellingPriceTax',
                          duoField: 'requestSellingPriceTax',
                          colorRed: true,
                      }
                    : {
                          field: 'discountedRequestSellingPrice',
                          duoField: 'requestSellingPrice',
                          colorRed: true,
                      },
                {
                    field: 'salesStartDate',
                },
                {
                    field: 'salesEndDate',
                },
                {
                    field: 'freshnessReason',
                },
                {
                    field: 'tax',
                    value: taxIncludedType,
                },
                {
                    field: 'otherSpecialReports',
                },
            ],
        },
    };
};

export const getExcelUploadTable = (expandSalesFloors, packingCategories, saleTypes) => {
    return {
        heads: [
            {
                title: 'JAN',
                field: 'jan',
                className: 'v-base_minWidth--95 v-base_width--6',
            },
            {
                title: '商品名',
                field: 'itemName',
                className: 'v-base_minWidth--95',
            },
            {
                title: '売場展開',
                field: 'expandSalesFloor',
                className: 'text-center',
            },
            {
                title: '競合店売価\n非会員価格',
                field: 'discountedRequestSellingPrice',
                className: 'text-center',
            },
            {
                title: '販売方法・荷姿',
                field: 'packingCategory',
                className: 'text-center',
            },
            {
                title: '特売種別・期間',
                field: 'saleType',
                className: 'text-center',
            },
            {
                title: '開始日',
                field: 'salesStartDate',
                className: 'text-center',
            },
            {
                title: '終了日',
                field: 'salesEndDate',
                className: 'text-center',
            },
            {
                title: 'その他特記事項',
                field: 'otherSpecialReports',
                className: 'text-center',
            },
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    field: 'itemName',
                    className: 'text-left',
                },
                {
                    field: 'expandSalesFloor',
                    mappingData: expandSalesFloors,
                },
                {
                    field: 'discountedRequestSellingPrice',
                    duoField: 'requestSellingPrice',
                    colorRed: true,
                },
                {
                    field: 'packingCategory',
                    mappingData: packingCategories,
                },
                {
                    field: 'saleType',
                    mappingData: saleTypes,
                },
                {
                    field: 'salesStartDate',
                },
                {
                    field: 'salesEndDate',
                },
                {
                    field: 'otherSpecialReports',
                },
            ],
        },
    };
};

export const getRequestingTable = (t, handleEditClick, isRequesting, isFreshness, isCompetitor) => {
    return {
        heads: [
            {
                title: t('price_request.result_list.jan'),
                field: 'jan',
                className: 'v-base_minWidth--95 v-base_width--6',
            },
            {
                title: t('price_request.result_list.product_image'),
                className: 'v-base_minWidth--30 v-base_width--3',
            },
            {
                title: t('price_request.result_list.product_name'),
                field: 'itemName',
                className: 'v-base_minWidth--115 v-width-auto cell-border',
            },
            {
                title: isFreshness ? '鮮度起因値下げ\n非会員価格' : t('price_request.result_list.discounted_competitor_selling_price'),
                field: 'discountedRequestSellingPrice',
                className: 'text-center v-base_minWidth--95 v-base_width--6',
            },
            {
                title: t('price_request.result_list.sales_start_date'),
                field: 'salesStartDate',
                className: 'v-base_minWidth--65 v-base_width--4',
            },
            {
                title: t('price_request.result_list.sales_end_date'),
                field: 'salesEndDate',
                className: 'v-base_minWidth--65 v-base_width--4 cell-border',
            },
            {
                title: t('price_registration.result_list.store_current_selling_price.title'),
                field: 'discountedLowestSellingPrice',
                className: 'v-base_minWidth--95 v-base_width--6',
            },
            {
                title: t('price_request.result_list.lowest_price_type'),
                field: 'lowestPriceType',
                className: 'v-base_minWidth--52 v-base_width--5',
            },
            {
                title: t('price_request.result_list.effective_end_date'),
                field: 'effectiveEndDate',
                className: 'v-base_minWidth--75 v-base_width--5 cell-border',
            },
            {
                title: t('price_request.result_list.competitor_store_name'),
                ...(isCompetitor
                    ? {
                          field: 'changeRequestCompetitorEntity.competitorCombinationMasterEntity.competitorStoreMasterEntity.competitorStoreName',
                      }
                    : {}),
                className: 'v-base_minWidth--65 v-base_width--10 cell-border',
                disabled: isFreshness,
            },
            {
                title: t('price_registration.result_list.nbpbkbn.title'),
                field: 'nbpbkbn', // DBのカラムでソートするためnbpbkbnを指定
                className:
                    isFreshness && isRequesting ? 'v-base_minWidth--65 v-base_width--4' : 'v-base_minWidth--65 v-base_width--4 cell-border',
            },
            {
                title: t('price_request.result_list.stop_purchase_flag'),
                className: 'v-base_minWidth--75 v-base_width--4',
                disabled: isFreshness,
            },
            {
                title: t('confirm_registration_price.remand.result_list.remand_reason'),
                className: 'v-base_minWidth--85 v-base_width--4',
                disabled: isRequesting,
            },
            {
                title: t('price_request.result_list.edit'),
                className: 'freeze-column freeze-right-53 cell-border-left v-base_width--3',
            },
            {
                title: t('price_request.result_list.select'),
                className: 'freeze-column freeze-right-0 cell-border-left',
            },
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    isLink: true,
                },
                {
                    field: 'itemName',
                    className: 'cell-border text-left',
                },
                {
                    field: 'discountedRequestSellingPrice',
                    duoField: 'requestSellingPrice',
                    colorRed: true,
                },
                {
                    field: 'salesStartDate',
                },
                {
                    field: 'salesEndDate',
                    className: 'cell-border',
                },
                {
                    field: 'discountedLowestSellingPrice',
                    duoField: 'lowestSellingPrice',
                },
                {
                    field: 'lowestPriceTypeName',
                },
                {
                    field: 'effectiveEndDate',
                    className: 'cell-border',
                },
                {
                    field: 'competitorName',
                    className: 'cell-border',
                    disabled: isFreshness,
                },
                {
                    field: 'nbpbkbn',
                    className: isFreshness && isRequesting ? '' : 'cell-border',
                },
                {
                    field: 'stopPurchaseFlag',
                    disabled: isFreshness,
                },
                {
                    field: 'remandReason',
                    disabled: isRequesting,
                },
                {
                    field: 'edit',
                    isButtonEdit: true,
                    className: 'edit-price freeze-column freeze-right-53 cell-border-left v-base_width--3',
                    onClick: (index, value) => {
                        handleEditClick(index, value);
                    },
                },
                {
                    field: 'selected',
                    isCheckbox: true,
                    className: 'freeze-column freeze-right-0 cell-border-left',
                },
            ],
        },
    };
};

export const getNotConfirmTable = (t, handleOnChange, isFreshness, isCompetitor, isHead) => {
    return {
        heads: [
            {
                title: t('price_request.result_list.jan'),
                field: 'jan',
                className: 'v-base_minWidth--95 v-base_width--6',
            },
            {
                title: t('price_request.result_list.product_image'),
                className: 'v-base_minWidth--30 v-base_width--3',
            },
            {
                title: t('price_request.result_list.product_name'),
                field: 'itemName',
                className: 'v-base_minWidth--115 v-width-auto cell-border',
            },
            ...(isHead
                ? [
                      {
                          title: t('price_request.result_list.division'),
                          field: 'departmentCode',
                          className: 'text-center v-base_minWidth--65 v-base_width--2 cell-border',
                      },
                  ]
                : []),
            {
                title: isFreshness ? '鮮度起因値下げ\n非会員価格' : t('price_request.result_list.discounted_competitor_selling_price'),
                field: 'discountedRequestSellingPrice',
                isSort: true,
                type: 'ASC',
                className: 'text-center v-base_minWidth--95 v-base_width--6',
            },
            {
                title: t('price_request.result_list.sales_start_date'),
                field: 'salesStartDate',
                isSort: true,
                type: 'ASC',
                className: 'v-base_minWidth--65 v-base_width--4',
            },
            {
                title: t('price_request.result_list.sales_end_date'),
                field: 'salesEndDate',
                isSort: true,
                type: 'ASC',
                className: 'v-base_minWidth--65 v-base_width--4 cell-border',
            },
            {
                title: t('price_registration.result_list.store_current_selling_price.title'),
                field: 'discountedLowestSellingPrice',
                isSort: true,
                type: 'ASC',
                className: 'v-base_minWidth--95 v-base_width--6',
            },
            {
                title: t('price_request.result_list.lowest_price_type'),
                field: 'lowestPriceType',
                isSort: true,
                type: 'ASC',
                className: 'v-base_minWidth--52 v-base_width--5',
            },
            {
                title: t('price_request.result_list.effective_end_date'),
                field: 'effectiveEndDate',
                isSort: true,
                type: 'ASC',
                className: 'v-base_minWidth--75 v-base_width--5 cell-border',
            },
            {
                title: t('price_request.result_list.competitor_store_name'),
                ...(isCompetitor
                    ? {
                          field: 'changeRequestCompetitorEntity.competitorCombinationMasterEntity.competitorStoreMasterEntity.competitorStoreName',
                      }
                    : {}),
                className: 'v-base_minWidth--65 v-base_width--10 cell-border',
                disabled: isFreshness,
            },
            {
                title: t('price_registration.result_list.nbpbkbn.title'),
                field: 'nbpbkbn', // DBのカラムでソートするためnbpbkbnを指定
                isSort: true,
                type: 'ASC',
                className: isFreshness ? 'v-base_minWidth--65 v-base_width--4' : 'v-base_minWidth--65 v-base_width--4 cell-border',
            },
            {
                title: t('price_request.result_list.stop_purchase_flag'),
                className: 'v-base_minWidth--75 v-base_width--4',
                disabled: isFreshness,
            },
            ...(isHead
                ? [
                      {
                          title: t('confirm_registration_price.result_list.determine'),
                          className: 'v-base_minWidth--52 freeze-column freeze-right-53 cell-border-left',
                      },
                      {
                          title: t('confirm_registration_price.result_list.delete'),
                          className: 'v-base_minWidth--52 freeze-column freeze-right-0 cell-border-left',
                      },
                  ]
                : [
                      {
                          title: t('confirm_registration_price.result_list.determine'),
                          className: 'v-base_minWidth--53 freeze-column freeze-right-133 cell-border-left',
                      },
                      {
                          title: t('confirm_registration_price.result_list.remand_reason_flg'),
                          className: 'v-base_minWidth--53 freeze-column freeze-right-80 cell-border-left',
                      },
                      {
                          title: t('confirm_registration_price.result_list.remand_reason'),
                          className: 'v-base_minWidth--80 freeze-column freeze-right-0 cell-border-left',
                          type: 'textarea',
                      },
                  ]),
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    isLink: true,
                },
                {
                    field: 'itemName',
                    className: 'cell-border text-left',
                },
                ...(isHead
                    ? [
                          {
                              field: 'departmentName',
                              className: 'cell-border',
                          },
                      ]
                    : []),
                {
                    field: 'discountedRequestSellingPrice',
                    duoField: 'requestSellingPrice',
                    colorRed: true,
                },
                {
                    field: 'salesStartDate',
                },
                {
                    field: 'salesEndDate',
                    className: 'cell-border',
                },
                {
                    field: 'discountedLowestSellingPrice',
                    duoField: 'lowestSellingPrice',
                },
                {
                    field: 'lowestPriceTypeName',
                },
                {
                    field: 'effectiveEndDate',
                    className: 'cell-border',
                },
                {
                    field: 'competitorName',
                    disabled: isFreshness,
                    className: 'cell-border',
                },
                {
                    field: 'nbpbkbn',
                    className: isFreshness ? '' : 'cell-border',
                },
                {
                    field: 'stopPurchaseFlag',
                    disabled: isFreshness,
                },
                ...(isHead
                    ? [
                          {
                              field: 'confirmed',
                              isCheckbox: true,
                              className: 'freeze-column freeze-right-53 cell-border-left',
                          },
                          {
                              field: 'remand',
                              isCheckbox: true,
                              className: 'freeze-column freeze-right-0 cell-border-left',
                          },
                      ]
                    : [
                          {
                              field: 'confirmed',
                              isCheckbox: true,
                              className: 'freeze-column freeze-right-133 cell-border-left',
                          },
                          {
                              field: 'remand',
                              isCheckbox: true,
                              className: 'freeze-column freeze-right-80 cell-border-left',
                          },
                          {
                              field: 'remandReason',
                              isInput: true,
                              className: 'v-base_width--2 freeze-column freeze-right-0 cell-border-left',
                              maxLength: 30,
                              onChange: (id, value) => {
                                  handleOnChange(id, value);
                              },
                          },
                      ]),
            ],
        },
    };
};

export const getProhibitedItemsTable = (t, isFreshness) => {
    return {
        heads: [
            {
                title: 'JAN',
                field: 'jan',
                className: 'v-base_minWidth--190 v-base_width--6',
            },
            {
                title: '商品名',
                field: 'itemName',
                className: 'v-base_minWidth--220',
            },
            {
                title: isFreshness ? '鮮度起因値下げ\n非会員価格' : '競合店売価\n非会員価格',
                field: 'discountedRequestSellingPrice',
                className: 'v-base_minWidth--160',
            },
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    field: 'itemName',
                    className: 'text-left',
                },
                {
                    field: 'discountedRequestSellingPrice',
                    duoField: 'requestSellingPrice',
                    colorRed: true,
                },
            ],
        },
    };
};

export const getNbpbkbnTable = (t) => {
    return {
        heads: [
            {
                title: 'JAN',
                field: 'jan',
                className: 'v-base_minWidth--190 v-base_width--6',
            },
            {
                title: '商品名',
                field: 'itemName',
                className: 'v-base_minWidth--220',
            },
            {
                title: '競合店売価\n非会員価格',
                field: 'discountedRequestSellingPrice',
                className: 'v-base_minWidth--160',
            },
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    field: 'itemName',
                    className: 'text-left',
                },
                {
                    field: 'discountedRequestSellingPrice',
                    duoField: 'requestSellingPrice',
                    colorRed: true,
                },
            ],
        },
    };
};

export const getExcelValidationTable = (t) => {
    return {
        heads: [
            {
                title: '行番号',
                field: 'rowNumber',
                className: 'v-base_minWidth--190 v-base_width--6',
            },
            {
                title: 'エラーメッセージ',
                field: 'message',
                className: 'v-base_minWidth--220',
            },
        ],
        body: {
            columns: [
                {
                    field: 'rowNumber',
                },
                {
                    field: 'message',
                },
            ],
        },
    };
};

export const getTableUpdateCompetitorMaster = (t) => {
    return {
        heads: [
            {
                title: t('update_competitor_master.table.head.requested_date'),
                field: 'createdDate',
                className: 'v-base_minWidth--93 v-base_width--6',
            },
            {
                title: t('update_competitor_master.table.head.store_name'),
                field: 'storeName',
                className: 'v-base_minWidth--130 v-base_width--8 cell-border',
            },
            {
                title: t('update_competitor_master.table.head.business_format'),
                className: 'v-base_minWidth--115 v-base_width--9',
            },
            {
                title: t('update_competitor_master.table.head.chain_name'),
                className: 'v-base_minWidth--170 v-base_width--7',
            },
            {
                title: t('update_competitor_master.table.head.competitive_store_name'),
                className: 'v-base_minWidth--265 v-base_width--9',
            },
            {
                title: t('update_competitor_master.table.head.distance'),
                className: 'v-base_minWidth--120 v-base_width--8',
            },
            {
                title: t('update_competitor_master.table.head.system_rank'),
                className: 'v-base_minWidth--100 v-base_width--5',
            },
            {
                title: t('update_competitor_master.table.head.store_rank'),
                className: 'v-base_minWidth--130 v-base_width--6',
            },
            {
                title: t('update_competitor_master.table.head.notification_flag'),
                className: 'freeze-column v-base_minWidth--52 v-base_width--6 cell-border-left freeze-right-0',
            },
        ],
        body: {
            columns: [
                {
                    field: 'createdDate',
                    className: 'freeze-column',
                },
                {
                    field: 'storeName',
                    className: 'cell-border freeze-column',
                },
                {
                    field: 'businessFormat',
                    className: 'freeze-column',
                },
                {
                    field: 'competitorChainName',
                    className: 'freeze-column',
                },
                {
                    field: 'competitorStoreName',
                    className: 'freeze-column',
                },
                {
                    field: 'distanceName',
                    className: 'freeze-column',
                },
                {
                    field: 'systemRankName',
                    className: 'freeze-column',
                },
                {
                    field: 'storeRankName',
                    className: 'freeze-column',
                },
                {
                    field: 'notificationFlag',
                    isCheckbox: true,
                    className: 'freeze-column freeze-right-0 cell-border-left',
                    checkboxDisabled: true,
                },
            ],
        },
    };
};

export const getAdminTable = (t, handleDeleteClick, handleEditClick) => {
    return {
        heads: [
            {
                title: t('user.label.authority'),
                field: 'authorityName',
                className: 'v-base_minWidth--12 v-base_width--3',
            },
            {
                title: t('user.label.organization'),
                field: 'organizationName',
                className: 'v-base_minWidth--12 v-base_width--2',
            },
            {
                title: t('user.label.store'),
                field: 'storeName',
                className: 'v-base_minWidth--60  v-base_width--4',
            },
            {
                title: t('user.label.allow_change_request_without_validation'),
                field: 'allowChangeRequestWithoutValidation',
                className: 'v-base_minWidth--60  v-base_width--2',
            },
            {
                title: t('user.label.account'),
                field: 'email',
                className: 'v-base_minWidth--93 v-base_width--12',
            },
            {
                title: t('user.label.last_login_at'),
                field: 'lastLoginAt',
                className: 'v-base_minWidth--40 v-base_width--5',
            },
            {
                title: t('user.label.edit'),
                className: 'v-base_minWidth--40 v-base_width--2',
            },
            {
                title: t('user.label.delete'),
                className: 'v-base_minWidth--40 v-base_width--2',
            },
        ],
        body: {
            columns: [
                {
                    field: 'authorityName',
                    className: 'freeze-column',
                },
                {
                    field: 'organizationName',
                    className: 'freeze-column',
                },
                {
                    field: 'storeName',
                    className: 'freeze-column',
                },
                {
                    field: 'allowChangeRequestWithoutValidation',
                    className: 'freeze-column',
                },
                {
                    field: 'email',
                    className: 'freeze-column',
                },
                {
                    field: 'lastLoginAt',
                    className: 'freeze-column',
                },
                {
                    field: 'confirmDeleteModal',
                    isButtonEdit: true,
                    label: 'remandReasonFlg',
                    className: 'freeze-column',
                    onClick: (index, value) => {
                        handleEditClick(index, value);
                    },
                },
                {
                    field: 'confirmDeleteModal',
                    isButtonDelete: true,
                    label: 'remandReasonFlg',
                    className: 'freeze-column',
                    onClick: (index, value) => {
                        handleDeleteClick(index, value);
                    },
                },
            ],
        },
    };
};

export const getProhibitedItemTable = (handleEditClick) => {
    return {
        heads: [
            {
                title: 'JAN',
                field: 'jan',
                className: 'v-base_minWidth--115 v-base_width--4',
            },
            {
                title: '商品名',
                field: 'itemName',
                className: 'v-base_minWidth--265 v-base_width--6',
            },
            {
                title: '部門',
                field: 'departmentCode',
                className: 'v-base_minWidth--50 v-base_width--7',
            },
            {
                title: '本部マスタ価格',
                field: 'sellingPrice',
                className: 'v-base_minWidth--115 v-base_width--5',
            },
            {
                title: '下限値',
                field: 'lowerLimit',
                className: 'v-base_minWidth--50 v-base_width--8',
            },
            {
                title: '禁止',
                className: 'v-base_minWidth--30 v-base_width--5',
            },
            {
                title: '開始日',
                field: 'startDate',
                className: 'v-base_minWidth--50 v-base_width--6',
            },
            {
                title: '終了日',
                field: 'endDate',
                className: 'v-base_minWidth--50 v-base_width--6',
            },
            {
                title: '更新日',
                field: 'updatedAt',
                className: 'v-base_minWidth--80 v-base_width--7',
            },
            {
                title: '編集',
                className: 'v-base_minWidth--57 v-base_width--3 freeze-column freeze-right-0',
            },
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    field: 'itemName',
                    className: 'text-left',
                },
                {
                    field: 'departmentName',
                },
                {
                    field: 'sellingPrice',
                },
                {
                    field: 'lowerLimit',
                },
                {
                    field: 'deleteFlag',
                    isCheckbox: true,
                    checkboxDisabled: true,
                    reverse: true, // 削除されていないときにチェックを入れる
                },
                {
                    field: 'startDate',
                },
                {
                    field: 'endDate',
                },
                {
                    field: 'updatedAt',
                },
                {
                    field: 'edit',
                    isButtonEdit: true,
                    className: 'freeze-column freeze-right-0',
                    onClick: (index, value) => {
                        handleEditClick(index, value);
                    },
                },
            ],
        },
    };
};

export const getExceptionItemTable = (t, handleDeleteClick) => {
    return {
        heads: [
            {
                title: t('exception_product_list.result_list.jan'),
                field: 'jan',
                className: 'v-base_minWidth--65 v-base_width--5',
            },
            {
                title: t('exception_product_list.result_list.product_name'),
                field: 'itemName',
                className: 'v-base_minWidth--65 v-base_width--15',
            },
            {
                title: t('exception_product_list.result_list.department'),
                field: 'departmentCode',
                className: 'v-base_minWidth--65 v-base_width--4',
            },
            {
                title: t('exception_product_list.result_list.created_at'),
                field: 'createdAt',
                className: 'v-base_minWidth--65 v-base_width--3 cell-border',
            },
            {
                title: '削除',
                className: 'v-base_minWidth--65 v-base_width--2',
            },
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    field: 'itemName',
                    className: 'text-left',
                },
                {
                    field: 'departmentName',
                },
                {
                    field: 'createdAt',
                    className: 'cell-border',
                },
                {
                    field: 'delete',
                    isButtonDelete: true,
                    onClick: (index, value) => {
                        handleDeleteClick(index, value);
                    },
                },
            ],
        },
    };
};

export const getProhibitedCategoryTable = (isException) => {
    return {
        heads: [
            {
                title: '部門',
                field: 'departmentName',
                className: 'v-base_minWidth--12 v-base_width--3',
            },
            {
                title: 'ライン',
                field: 'lineName',
                className: 'v-base_minWidth--12 v-base_width--3',
            },
            {
                title: 'クラス',
                field: 'className',
                className: 'v-base_minWidth--12 v-base_width--3',
            },
            {
                title: 'サブクラス',
                field: 'subclassName',
                className: 'v-base_minWidth--12 v-base_width--3',
            },
            {
                title: '値入率',
                field: 'markupRate',
                className: 'v-base_minWidth--12 v-base_width--3',
                disabled: isException,
            },
        ],
        body: {
            columns: [
                {
                    field: 'departmentName',
                    className: 'freeze-column',
                },
                {
                    field: 'lineName',
                    className: 'freeze-column',
                },
                {
                    field: 'className',
                    className: 'freeze-column',
                },
                {
                    field: 'subclassName',
                    className: 'freeze-column',
                },
                {
                    field: 'markupRate',
                    className: 'freeze-column',
                    disabled: isException,
                },
            ],
        },
    };
};

export const getTableRequestDissociatedTab = (t, handleDeleteClick) => {
    return {
        heads: [
            {
                title: t('notification_registration.table.head.email'),
                field: 'email',
                className: 'freeze-column',
            },
            {
                title: t('notification_registration.table.head.department'),
                field: 'departmentName',
                className: 'freeze-column',
            },
            {
                title: t('notification_registration.table.head.registration_date'),
                field: 'createdAt',
                className: 'freeze-column',
            },
            {
                title: t('notification_registration.table.head.delete'),
                className: 'freeze-column',
            },
        ],
        body: {
            columns: [
                {
                    field: 'email',
                    className: 'freeze-column',
                },
                {
                    field: 'departmentName',
                    className: 'freeze-column',
                },
                {
                    field: 'createdAt',
                    className: 'freeze-column',
                },
                {
                    field: 'confirmDeleteModal',
                    isButtonDelete: true,
                    label: 'remandReasonFlg',
                    className: 'freeze-column',
                    onClick: (index, value) => {
                        handleDeleteClick(index, value);
                    },
                },
            ],
        },
    };
};

export const getTableNearbyStoreTab = (t, handleDeleteClick) => {
    return {
        heads: [
            {
                title: t('notification_registration.table.head.email'),
                field: 'email',
                className: 'freeze-column',
            },
            {
                title: t('notification_registration.table.head.registration_date'),
                field: 'createdAt',
                className: 'freeze-column',
            },
            {
                title: t('notification_registration.table.head.delete'),
                className: 'freeze-column',
            },
        ],
        body: {
            columns: [
                {
                    field: 'email',
                    className: 'freeze-column',
                },
                {
                    field: 'createdAt',
                    className: 'freeze-column',
                },
                {
                    field: 'confirmDeleteModal',
                    isButtonDelete: true,
                    label: 'remandReasonFlg',
                    className: 'freeze-column',
                    onClick: (index, value) => {
                        handleDeleteClick(index, value);
                    },
                },
            ],
        },
    };
};

export const getTableBelowCostTab = (t, handleDeleteClick) => {
    return {
        heads: [
            {
                title: t('notification_registration.table.head.email'),
                field: 'email',
                className: 'freeze-column',
            },
            {
                title: t('notification_registration.table.head.department'),
                field: 'departmentName',
                className: 'freeze-column',
            },
            {
                title: t('notification_registration.table.head.registration_date'),
                field: 'createdAt',
                className: 'freeze-column',
            },
            {
                title: t('notification_registration.table.head.delete'),
                className: 'freeze-column',
            },
        ],
        body: {
            columns: [
                {
                    field: 'email',
                    className: 'freeze-column',
                },
                {
                    field: 'departmentName',
                    className: 'freeze-column',
                },
                {
                    field: 'createdAt',
                    className: 'freeze-column',
                },
                {
                    field: 'confirmDeleteModal',
                    isButtonDelete: true,
                    label: 'remandReasonFlg',
                    className: 'freeze-column',
                    onClick: (index, value) => {
                        handleDeleteClick(index, value);
                    },
                },
            ],
        },
    };
};

export const getTableRequestApplyCompetitorStoreTab = (t, handleDeleteClick) => {
    return {
        heads: [
            {
                title: t('notification_registration.table.head.email'),
                field: 'email',
                className: 'freeze-column',
            },
            {
                title: t('notification_registration.table.head.registration_date'),
                field: 'createdAt',
                className: 'freeze-column',
            },
            {
                title: t('notification_registration.table.head.delete'),
                className: 'freeze-column',
            },
        ],
        body: {
            columns: [
                {
                    field: 'email',
                    className: 'freeze-column',
                },
                {
                    field: 'createdAt',
                    className: 'freeze-column',
                },
                {
                    field: 'confirmDeleteModal',
                    isButtonDelete: true,
                    label: 'remandReasonFlg',
                    className: 'freeze-column',
                    onClick: (index, value) => {
                        handleDeleteClick(index, value);
                    },
                },
            ],
        },
    };
};

export const getTableChangeRequestApproved = (t, isHeadquarter, isInstruction) => {
    return {
        heads: [
            {
                title: t('approved_registration_price.result_list.status'),
                className: 'v-base_minWidth--65 v-base_width--6',
            },
            {
                title: t('approved_registration_price.result_list.ok_store_name'),
                className: 'v-base_minWidth--130 v-base_width--4',
                disabled: !isHeadquarter,
            },
            {
                title: t('approved_registration_price.result_list.tokubai_project_code'),
                className: 'v-base_minWidth--80 v-base_width--6',
            },
            {
                title: t('approved_registration_price.result_list.competitor_store_name'),
                className: 'v-base_minWidth--130 v-base_width--4',
            },
            {
                title: t('approved_registration_price.result_list.jan'),
                field: 'jan',
                className: 'v-base_minWidth--115 v-base_width--4',
            },
            {
                title: t('approved_registration_price.result_list.product_image'),
                className: 'v-base_minWidth--30 v-base_width--3',
            },
            {
                title: t('approved_registration_price.result_list.product_name'),
                field: 'itemName',
                className: 'v-base_minWidth--220 v-base_width--4',
            },
            {
                title: t('price_registration.result_list.store_current_selling_price.title'),
                className: 'v-base_minWidth--95 v-base_width--5',
            },
            {
                title: t('approved_registration_price.result_list.competitor_selling_unit_price'),
                className: 'v-base_minWidth--95 v-base_width--5',
            },
            {
                title: t('approved_registration_price.result_list.start_date'),
                className: 'text-center v-base_minWidth--85 v-base_width--4',
            },
            {
                title: t('approved_registration_price.result_list.end_date'),
                className: 'v-base_minWidth--85 v-base_width--4',
            },
            {
                title: '削除済み',
                className: 'v-base_minWidth--30 v-base_width--5',
            },
            {
                title: t('approved_registration_price.result_list.delete'),
                className: 'text-center v-base_minWidth--65 v-base_width--2 freeze-column freeze-right-0 cell-border-left',
                disabled: isInstruction,
            },
        ],
        body: {
            columns: [
                {
                    field: 'status',
                },
                {
                    field: 'storeName',
                    disabled: !isHeadquarter,
                },
                {
                    field: 'tokubaiProjectCode',
                },
                {
                    field: 'competitorStoreName',
                },
                {
                    field: 'jan',
                },
                {
                    isLink: true,
                },
                {
                    field: 'itemName',
                    className: 'text-left',
                },
                {
                    field: 'discountedLowestSellingPrice',
                    duoField: 'lowestSellingPrice',
                },
                {
                    field: 'discountedRequestSellingPrice',
                    duoField: 'requestSellingPrice',
                    colorRed: true,
                },
                {
                    field: 'startDate',
                },
                {
                    field: 'endDate',
                },
                {
                    field: 'deleteFlag',
                    isCheckbox: true,
                    checkboxDisabled: true,
                },
                {
                    field: 'selected',
                    isCheckbox: true,
                    className: 'freeze-column freeze-right-0 cell-border-left',
                    disabled: isInstruction,
                },
            ],
        },
    };
};

export const getTableFreshnessChangeRequestApproved = (t, isHeadquarter) => {
    return {
        heads: [
            {
                title: t('approved_registration_price.result_list.status'),
                className: 'v-base_minWidth--65 v-base_width--6',
            },
            {
                title: t('approved_registration_price.result_list.ok_store_name'),
                className: 'v-base_minWidth--130 v-base_width--4',
                disabled: !isHeadquarter,
            },
            {
                title: t('approved_registration_price.result_list.jan'),
                field: 'jan',
                className: 'v-base_minWidth--115 v-base_width--4',
            },
            {
                title: t('approved_registration_price.result_list.product_image'),
                className: 'v-base_minWidth--30 v-base_width--3',
            },
            {
                title: t('approved_registration_price.result_list.product_name'),
                field: 'itemName',
                className: 'v-base_minWidth--220 v-base_width--4',
            },
            {
                title: t('price_registration.result_list.store_current_selling_price.title'),
                className: 'v-base_minWidth--95 v-base_width--5',
            },
            {
                title: t('approved_registration_price.result_list.freshness_selling_unit_price'),
                className: 'v-base_minWidth--95 v-base_width--5',
            },
            {
                title: t('approved_registration_price.result_list.start_date'),
                className: 'text-center v-base_minWidth--85 v-base_width--4',
            },
            {
                title: t('approved_registration_price.result_list.end_date'),
                className: 'v-base_minWidth--85 v-base_width--4',
            },
            {
                title: '削除済み',
                className: 'v-base_minWidth--30 v-base_width--5',
            },
            {
                title: t('approved_registration_price.result_list.delete'),
                className: 'text-center v-base_minWidth--65 v-base_width--2 freeze-column freeze-right-0 cell-border-left',
            },
        ],
        body: {
            columns: [
                {
                    field: 'status',
                },
                {
                    field: 'storeName',
                    disabled: !isHeadquarter,
                },
                {
                    field: 'jan',
                },
                {
                    isLink: true,
                },
                {
                    field: 'itemName',
                    className: 'text-left',
                },
                {
                    field: 'discountedLowestSellingPrice',
                    duoField: 'lowestSellingPrice',
                },
                {
                    field: 'discountedRequestSellingPrice',
                    duoField: 'requestSellingPrice',
                    colorRed: true,
                },
                {
                    field: 'startDate',
                },
                {
                    field: 'endDate',
                },
                {
                    field: 'deleteFlag',
                    isCheckbox: true,
                    checkboxDisabled: true,
                },
                {
                    field: 'selected',
                    isCheckbox: true,
                    className: 'freeze-column freeze-right-0 cell-border-left',
                },
            ],
        },
    };
};

export const getTableChangeRequestApprovedHeadquarter = (t) => {
    return {
        heads: [
            {
                title: t('approved_headquarter.result_list.competitive_chain'),
                className: 'v-base_minWidth--65 v-base_width--6',
            },
            {
                title: t('approved_headquarter.result_list.jan'),
                field: 'jan',
                className: 'v-base_minWidth--115 v-base_width--4',
            },
            {
                title: t('approved_headquarter.result_list.product_image'),
                className: 'v-base_minWidth--30 v-base_width--3',
            },
            {
                title: t('approved_headquarter.result_list.product_name'),
                field: 'itemName',
                className: 'v-base_minWidth--220 v-base_width--4',
            },
            {
                title: t('approved_headquarter.result_list.competitor_selling_unit_price'),
                className: 'v-base_minWidth--95 v-base_width--5',
            },
            {
                title: t('approved_headquarter.result_list.start_date'),
                className: 'text-center v-base_minWidth--85 v-base_width--4',
            },
            {
                title: t('approved_headquarter.result_list.end_date'),
                className: 'v-base_minWidth--85 v-base_width--4',
            },
            {
                title: t('approved_headquarter.result_list.deleted'),
                className: 'v-base_minWidth--30 v-base_width--5',
            },
            {
                title: t('approved_headquarter.result_list.choice'),
                className: 'text-center v-base_minWidth--65 v-base_width--2 freeze-column freeze-right-0 cell-border-left',
            },
        ],
        body: {
            columns: [
                {
                    field: 'competitorStoreName',
                },
                {
                    field: 'jan',
                },
                {
                    isLink: true,
                },
                {
                    field: 'itemName',
                    className: 'text-left',
                },
                {
                    field: 'discountedRequestSellingPrice',
                    duoField: 'requestSellingPrice',
                    colorRed: true,
                },
                {
                    field: 'startDate',
                },
                {
                    field: 'endDate',
                },
                {
                    field: 'deleteFlag',
                    isCheckbox: true,
                    checkboxDisabled: true,
                },
                {
                    field: 'selected',
                    isCheckbox: true,
                    className: 'freeze-column freeze-right-0 cell-border-left',
                },
            ],
        },
    };
};

export const getEdlpTable = (t, isFreshness) => {
    return {
        heads: [
            {
                title: t('price_request.result_list.jan'),
                field: 'jan',
                className: 'v-base_minWidth--95 v-base_width--6',
            },
            {
                title: t('price_request.result_list.product_name'),
                field: 'itemName',
                className: 'v-base_minWidth--115 v-width-auto',
            },
            {
                title: t('price_request.result_list.lowest_price_type'),
                field: 'lowestPriceTypeName',
                className: 'v-base_minWidth--115 v-width-auto',
            },
            {
                title: t('price_request.result_list.edlp_selling_price'),
                field: 'discountedEdlpSellingPrice',
                className: 'v-base_minWidth--115 v-width-auto',
            },
            !isFreshness && {
                title: t('price_request.result_list.lowest_selling_price'),
                field: 'discountedLowestSellingPrice',
                className: 'v-base_minWidth--115 v-width-auto',
            },
            {
                title: !isFreshness
                    ? t('price_request.result_list.discounted_competitor_selling_price')
                    : t('freshness.price_request.discounted_freshness_selling_price'),
                field: 'sellingPrice',
                className: 'v-base_minWidth--115 v-width-auto',
            },
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    field: 'itemName',
                    className: 'text-left',
                },
                {
                    field: 'lowestPriceTypeName',
                },
                {
                    // テーブルでは更徳と比較して安い金額を表示
                    field: 'discountedEdlpSellingPrice',
                    duoField: 'edlpSellingPrice',
                },
                !isFreshness && {
                    field: 'discountedLowestSellingPrice',
                    duoField: 'lowestSellingPrice',
                },
                {
                    field: 'discountedRequestSellingPrice',
                    duoField: 'requestSellingPrice',
                    colorRed: true,
                },
            ],
        },
    };
};

export const getVariantProductsTable = (t) => {
    return {
        heads: [
            {
                title: t('price_registration.different_capacity.table.jan'),
                field: 'jan',
                className: 'v-base_minWidth--95 v-base_width--6',
            },
            {
                title: t('price_registration.different_capacity.table.item_name'),
                field: 'productName',
                className: 'v-base_minWidth--115 v-width-auto',
            },
            {
                title: t('price_registration.different_capacity.table.similar_item_name'),
                field: 'variantProductName',
                className: 'v-base_minWidth--115 v-width-auto',
            },
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    field: 'productName',
                    className: 'text-left',
                },
                {
                    field: 'variantProductName',
                    className: 'text-left',
                },
            ],
        },
    };
};

export const getLowerLimitTable = (t) => {
    return {
        heads: [
            {
                title: t('price_registration.competitor_prohibited_items_modal.body.table.jan'),
                field: 'jan',
                className: 'v-base_minWidth--95 v-width-auto',
            },
            {
                title: t('price_registration.competitor_prohibited_items_modal.body.table.item_name'),
                field: 'itemName',
                className: 'v-base_minWidth--115 v-width-auto',
            },
            {
                title: t('price_registration.competitor_prohibited_items_modal.body.table.lower_limit'),
                field: 'lowerLimit',
                className: 'v-base_minWidth--95 v-base_width--6',
            },
        ],
        body: {
            columns: [
                {
                    field: 'jan',
                },
                {
                    field: 'itemName',
                    className: 'text-left',
                },
                {
                    field: 'lowerLimit',
                },
            ],
        },
    };
};

export const getTableCompetitorChain = (t, handleEditClick, handleDeleteClick) => {
    return {
        heads: [
            {
                title: t('competitor_master.search_form.competitor_chain_code.text'),
                field: 'chainCode',
                className: 'v-base_minWidth--170 v-base_width--7',
            },
            {
                title: t('update_competitor_master.table.head.business_format'),
                field: 'businessFormatName',
                className: 'v-base_minWidth--115 v-base_width--9',
            },
            {
                title: t('update_competitor_master.table.head.chain_name'),
                field: 'chainName',
                className: 'v-base_minWidth--170 v-base_width--7',
            },
            {
                title: '編集',
                className: 'v-base_minWidth--57 v-base_width--3 freeze-column freeze-right-0',
            },
            {
                title: '削除',
                className: 'v-base_minWidth--65 v-base_width--2',
            },
        ],
        body: {
            columns: [
                {
                    field: 'chainCode',
                    className: 'freeze-column',
                },
                {
                    field: 'businessFormatName',
                    className: 'freeze-column',
                },
                {
                    field: 'chainName',
                    className: 'freeze-column',
                },
                {
                    field: 'edit',
                    isButtonEdit: true,
                    className: 'freeze-column freeze-right-0',
                    onClick: (index, value) => {
                        handleEditClick(index, value);
                    },
                },
                {
                    field: 'delete',
                    isButtonDelete: true,
                    onClick: (index, value) => {
                        handleDeleteClick(index, value);
                    },
                },
            ],
        },
    };
};

export const getTableCompetitorStore = (t, handleEditClick, handleDeleteClick) => {
    return {
        heads: [
            {
                title: t('competitor_master.search_form.competitor_store_code.text'),
                field: 'competitorCode',
                className: 'v-base_minWidth--265 v-base_width--9',
            },
            {
                title: t('update_competitor_master.table.head.competitive_store_name'),
                field: 'competitorStoreName',
                className: 'v-base_minWidth--265 v-base_width--9',
            },
            {
                title: '編集',
                className: 'v-base_minWidth--57 v-base_width--3 freeze-column freeze-right-0',
            },
            {
                title: '削除',
                className: 'v-base_minWidth--65 v-base_width--2',
            },
        ],
        body: {
            columns: [
                {
                    field: 'competitorCode',
                    className: 'freeze-column',
                },
                {
                    field: 'competitorStoreName',
                    className: 'freeze-column',
                },
                {
                    field: 'edit',
                    isButtonEdit: true,
                    className: 'freeze-column freeze-right-0',
                    onClick: (index, value) => {
                        handleEditClick(index, value);
                    },
                },
                {
                    field: 'delete',
                    isButtonDelete: true,
                    onClick: (index, value) => {
                        handleDeleteClick(index, value);
                    },
                },
            ],
        },
    };
};
